import React, { useEffect, useState } from 'react';
import { ActivityIndicator, StyleSheet, SafeAreaView, Image, Button, TextInput, View, TouchableOpacity, Animated } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import Login from './Login';
import SignUp from './SignUp';
import Play from './Play';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { styles, styleTheme } from "../themes/styles"
import { storeCache, getCache } from '../utils/cacheStore'
import { serverURL } from '../constants/serverURL'
import UserAccount from './UserAccount';
import PlayerRankings from './PlayerRankings';
import GameMenu from './GameMenu';
import ChatWindow from './ChatWindow';
import GameIframe from './GameIframe';
import Game from './Game';


const Tab = createMaterialTopTabNavigator();

const GameScreen = (props) => {
    const [chatTitle, setChatTitle] = useState("Chat");

    const storeToken = (loginResponse) => {
        storeCache('token', loginResponse.token)
    };

    const handleAuthCheckResponse = (response) => {
        if (response.status != 200) {
            console.log("Auth check failed: ", response);
            response.json().then(data => storeToken(""));
            props.navigation.navigate('Login', {});
        }
    };

    const authCheck = () => {
        getCache("token").then((value) => {
            if (value == '') {
                return Promise.reject("do not auth check an empty token")
            }

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'jsd-auth': value },
                body: JSON.stringify({})
            };
            return requestOptions;
        }).then((requestOptions) => {
            console.log("Req options: ", requestOptions);
            return fetch(serverURL + '/user/verify/token', requestOptions);
        }).then((response) => {
            handleAuthCheckResponse(response);
        }).catch(() => {
            /* false */
        })
    };


    useEffect(() => {
        authCheck();

    }, []);

    useEffect(() => {
        const unsubscribe = props.navigation.addListener('tabPress', e => {
            // Prevent default behavior
            e.preventDefault();
            console.log("Tab press");
            // Do something manually
            // ...
        });

        return unsubscribe;
    }, [props.navigation]);

    return (
        <SafeAreaView style={styles.stickToTop}>
            <Tab.Navigator backBehavior="history"
                style={styles.homeMenu}
                barStyle={styles.tabNavContainer}
                tabBarOptions={styleTheme.tabNavigation}
            >
                <Tab.Screen name="Board" component={GameIframe} />
                {props.route.params.online == true &&
                <Tab.Screen name="Chat" component={ChatWindow} initialParams={{ username:  props.route.params.username, gameID: props.route.params.gameID, setChatTitle: setChatTitle}}/>
                }
                <Tab.Screen name="Menu" component={GameMenu} initialParams={{ itemId: 42 }}/>
            </Tab.Navigator>
        
        </SafeAreaView>
    );
}

export default GameScreen;
